export const getPagos = (idP) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", idP);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/Pagos`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}